<template>
    <div class="saas-page linear-admin-workflow">
        <div class="saas-hero card-saas linear-page-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{trans('backup.backup')}}</span>
                </p>
                <span class="linear-eyebrow">{{trans('backup.backup')}}</span>
                <h1 class="saas-hero__title">{{trans('backup.backup')}}</h1>
            </div>
        </div>
        <div class="card-saas linear-admin-panel mb-3">
            <div class="linear-section-head">
                <div>
                    <span>{{trans('backup.backup')}}</span>
                    <h4>{{trans('backup.generate_backup')}}</h4>
                </div>
            </div>
            <show-tip module="backup" tip="tip_backup"></show-tip>
            <div class="linear-backup-command">
                <div class="linear-switch-row">
                    <switches v-model="backupForm.delete_previous" theme="bootstrap" color="success"></switches>
                    <span>{{trans('backup.delete_previous_backup?')}}</span>
                    <show-tip module="backup" tip="tip_delete_previous_backup" type="field"></show-tip>
                </div>
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" @click.prevent="createBackup">{{trans('backup.generate_backup')}}</button>
            </div>
        </div>
        <div class="admin-list-table-card linear-table-card" v-if="backups && backups.length">
            <div class="linear-section-head linear-section-head--table">
                <div>
                    <span>{{trans('backup.backup')}}</span>
                    <h4>{{trans('backup.backup')}}</h4>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table admin-data-table linear-dense-table mb-0">
                    <thead>
                        <tr>
                            <th>{{trans('backup.name')}}</th>
                            <th>{{trans('backup.size')}}</th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="backup in backups" :key="backup.name">
                            <td><span class="linear-table-primary" v-text="backup.name"></span></td>
                            <td><span class="linear-pill" v-text="backup.size"></span></td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item :href="getDownloadLink(backup)" target="_blank">
                                        <admin-icon name="download"></admin-icon> Download
                                    </b-dropdown-item>
                                    <b-dropdown-item-button
                                        v-confirm="{ok: confirmDelete(backup)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> Delete Backup
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="admin-list-table-card admin-empty-state linear-empty-state" v-if="!backups.length" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="database"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('general.no_result_found') }}</h4>
                <p class="admin-empty-state__text">{{trans('backup.backup')}}</p>
            </div>
        </div>
    </div>
</template>


<script>
    import switches from 'vue-switches'

    export default {
        components : { switches },
        data() {
            return {
                backupForm: new Form({
                    delete_previous: false
                }),
                backups: [],
                filterBackupsForm: {
                    page_length: helper.getConfig('page_length')
                }
            };
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('backup')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getBackups();
        },
        methods: {
            createBackup(){
                this.backupForm.post('/api/backup')
                    .then(response => {
                        toastr.success(response.message);
                        this.getBackups();
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    })
            },
            getBackups(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterBackupsForm);
                axios.get('/api/backup?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.backups = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            confirmDelete(backup){
                return dialog => this.deleteBackup(backup);
            },
            deleteBackup(backup){
                axios.delete('/api/backup/'+backup.name)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getBackups();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getDownloadLink(backup){
                return '/backup/'+backup.name+'/download/?token='+localStorage.getItem('auth_token');
            },
        },
        filters: {
          momentDateTime(date) {
            return helper.formatDateTime(date);
          }
        }
    }
</script>

<style scoped>
.linear-page-hero {
    align-items: center;
}

.linear-eyebrow,
.linear-section-head span {
    color: #635bff;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-admin-panel {
    padding: 1.15rem;
}

.linear-section-head {
    margin-bottom: 1rem;
}

.linear-section-head h4 {
    margin: 0.25rem 0 0;
    color: #0f172a;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.linear-section-head--table {
    margin: 0;
    padding: 0.95rem 1.125rem;
    border-bottom: 1px solid #e2e8f0;
}

.linear-backup-command {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #f8fafc;
}

.linear-switch-row {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    color: #475569;
    font-weight: 700;
}

.linear-table-card,
.linear-empty-state {
    overflow: hidden;
    border-radius: 14px;
}

.linear-dense-table tbody td {
    vertical-align: middle;
}

.linear-table-primary {
    color: #0f172a;
    font-weight: 800;
}

.linear-pill {
    display: inline-flex;
    align-items: center;
    min-height: 1.5rem;
    padding: 0 0.6rem;
    border: 1px solid #e2e8f0;
    border-radius: 999px;
    color: #475569;
    background: #f8fafc;
    font-size: 0.75rem;
    font-weight: 800;
}

@media (max-width: 767.98px) {
    .linear-backup-command {
        align-items: flex-start;
        flex-direction: column;
    }
}

@media (max-width: 575.98px) {
    .linear-page-hero {
        align-items: flex-start;
    }
}
</style>
